/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Aroma_Sampling_Save_SuccessInputs */

const vi_toast_aroma_sampling_save_success = /** @type {(inputs: Toast_Aroma_Sampling_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lưu lần lấy hương`)
};

/**

* @param {Toast_Aroma_Sampling_Save_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_aroma_sampling_save_success = /** @type {((inputs?: Toast_Aroma_Sampling_Save_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Aroma_Sampling_Save_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_aroma_sampling_save_success(inputs)
});